import { render, staticRenderFns } from "./wizardDialog.vue?vue&type=template&id=724fcdd6&"
import script from "./wizardDialog.vue?vue&type=script&lang=js&"
export * from "./wizardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports